import axios from 'axios';
import { Config } from '../config';
import { SigninDto, TokenDto } from '../model/user.dto';

export class UserApi {
  public async getNewToken(refreshToken: string): Promise<TokenDto> {
    try {
        const url = `${Config.API_URL}/user/reissue`;
        const headers = {
            'Authorization': `Bearer ${refreshToken}`,
            'Content-Type': 'application/json'
        };
        const res = await axios.get<TokenDto>(url, { headers });
        return res.data;
    }
    catch {
        throw Error;
    }
  }

  public async login(dto: SigninDto): Promise<TokenDto | null> {
    try {
      const url = `${Config.API_URL}/user/signin`
      const res = await axios.post<TokenDto>(url, dto);
      return res.data;
    } catch (err) {
      return null;
    }
  }

  public async getUserName(accessToken: string): Promise<any[]> {
    try {
      if (!accessToken) {
          throw new Error('Refresh token not found');
      }
      const url = `${Config.API_URL}/user/profile`;
      const headers = {
          'Authorization': `Bearer ${accessToken}`,
          'accept': 'application/json'
      };
      const res = await axios.get(url, { headers });
      return res.data;
    } catch (error) {
      throw new Error('Network error');
    }
  }
}
